export const V2_PATH_PREFIX = '/v2';

export const isV2Path = (pathname: string): boolean =>
  pathname === V2_PATH_PREFIX || pathname.startsWith(`${V2_PATH_PREFIX}/`);

export const Path = {
  home: V2_PATH_PREFIX,
  redirect: `${V2_PATH_PREFIX}/redirect/`,
  identification: `${V2_PATH_PREFIX}/identification`,
  account: {
    signup: `${V2_PATH_PREFIX}/signup`,
    signin: `${V2_PATH_PREFIX}/signin`,
    validation: `${V2_PATH_PREFIX}/validation`,
    completed: `${V2_PATH_PREFIX}/account/completed`
  },
  application: {
    url: `${V2_PATH_PREFIX}/apply`,
    confirm: `${V2_PATH_PREFIX}/apply/confirm`,
    complete: `${V2_PATH_PREFIX}/apply/complete`
  }
};
